import { Outlet } from 'react-router-dom';
import { useEffect } from 'react';
// import { Phone } from 'lucide-react';
// import { trackWhatsAppClick } from '../utils/analytics';

const SalesLayout = () => {
  // const salesContacts = [
  //   { name: 'Junet', phone: '0822-3447-3421', waLink: '6282234473421' },
  //   { name: 'Dita', phone: '0812-4977-2025', waLink: '6281249772025' },
  //   { name: 'Anton', phone: '0812-5262-5700', waLink: '6281252625700' },
  // ];

  useEffect(() => {
    // Hide global WA widget when on Sales page
    const waWidget = document.querySelector('.wa-float');
    const waTooltip = document.querySelector('.wa-tooltip');
    
    if (waWidget) waWidget.style.display = 'none';
    if (waTooltip) waTooltip.style.display = 'none';

    return () => {
      // Restore global WA widget when leaving Sales page
      if (waWidget) waWidget.style.display = 'flex';
      if (waTooltip) waTooltip.style.display = '';
    };
  }, []);

  return (
    <div className="min-h-screen flex flex-col bg-emerald-50/30 overflow-x-hidden">
      {/* Header - Solid */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-emerald-950 shadow-lg">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex items-center justify-between h-20">
            {/* Logo (Not a link to home) */}
            <div className="flex items-center gap-3">
              <img
                src="https://res.cloudinary.com/dgfjos8xa/image/upload/v1769523647/logo_spencer_green_hotel_batu_malang_512_inv_h0zm3e.png"
                alt="Spencer Green Hotel Logo"
                className="h-10 w-auto brightness-0 invert"
              />
              <span className="font-display text-xl sm:text-2xl font-medium text-white drop-shadow-lg">
                Spencer Green
              </span>
            </div>
            {/* Title instead of menu */}
            <div className="hidden sm:block text-emerald-200 font-medium tracking-wide">
              Event Gallery
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1 pt-20">
        <Outlet />
      </main>

      {/* Minimal Footer with Contacts - DISABLED 
      <footer className="bg-emerald-950 text-white py-12">
        <div className="max-w-4xl mx-auto px-4">
          <div className="text-center mb-10">
            <h3 className="font-display text-2xl font-medium text-white mb-2">Hubungi Sales Team Kami</h3>
            <p className="text-emerald-200">Untuk informasi lebih lanjut dan reservasi event Anda.</p>
          </div>
          
          <div className="flex flex-wrap justify-center gap-6 md:gap-10">
            {salesContacts.map(contact => (
              <a
                key={contact.name}
                href={`https://wa.me/${contact.waLink}?text=Halo%20${contact.name},%20saya%20ingin%20tanya%20informasi%20paket%20event.`}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => trackWhatsAppClick(`Sales_${contact.name}`)}
                className="flex items-center gap-3 bg-emerald-900 hover:bg-emerald-800 px-6 py-4 rounded-xl transition-colors shadow-lg border border-emerald-800"
              >
                <div className="w-10 h-10 bg-emerald-700 rounded-full flex items-center justify-center">
                  <Phone className="w-5 h-5 text-white" />
                </div>
                <div className="text-left">
                  <p className="font-medium text-white">{contact.name}</p>
                  <p className="text-emerald-300 text-sm font-semibold">{contact.phone}</p>
                </div>
              </a>
            ))}
          </div>

          <div className="mt-16 pt-8 border-t border-emerald-900/50 text-center text-emerald-500 text-sm">
            <p>&copy; {new Date().getFullYear()} Spencer Green Hotel.</p>
          </div>
        </div>
      </footer>
      */}
    </div>
  );
};

export default SalesLayout;
